import { decodeJwt, extractRoles } from './utility';

/**
 * Convert to ISO string
 * @param sec {any}
 * @returns {string | null}
 */
function epochSecToIso(sec: any): string | null {
  if (typeof sec !== 'number' || !Number.isFinite(sec)) return null;
  return new Date(sec * 1000).toISOString();
}

/**
 * Given decoded JWT, returns user scopes
 * @param claims {any}
 * @returns {string[]}
 */
function extractScopes(claims: any): string[] {
  const fromScope =
    typeof claims?.scope === 'string'
      ? claims.scope.split(' ').filter(Boolean)
      : [];

  const fromScp = Array.isArray(claims?.scp) ? claims.scp : [];
  return Array.from(new Set([...fromScope, ...fromScp]));
}

/**
 * Given an accessToken string, method extracts details of the JWT
 * @param accessToken {string}
 * @param renewBeforeSeconds {number}
 * @returns {Record<string, unknown>}
 */
export function summarizeToken(
  accessToken: string,
  renewBeforeSeconds: number
): Record<string, unknown> {
  const claims = decodeJwt(accessToken) || {};
  const nowSec = Math.floor(Date.now() / 1000);

  const exp = typeof claims?.exp === 'number' ? claims.exp : null;
  const iat = typeof claims?.iat === 'number' ? claims.iat : null;

  const secondsRemaining = exp ? exp - nowSec : null;
  const renewAtSec = exp ? exp - renewBeforeSeconds : null;

  const user =
    claims?.user_name ||
    claims?.preferred_username ||
    claims?.email ||
    claims?.sub ||
    null;

  return {
    user,
    expIso: epochSecToIso(exp),
    iatIso: epochSecToIso(iat),
    secondsRemaining,
    renewAtIso: epochSecToIso(renewAtSec),
    iss: claims?.iss ?? null,
    aud: claims?.aud ?? null,
    azp: claims?.azp ?? null,
    scopes: extractScopes(claims),
    roles: extractRoles(claims)
  };
}
